export default __webpack_public_path__ + "static/media/transparent.5f919e4c.svg";